import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface SectionProps {
  id: string;
  title?: string;
  children: ReactNode;
  className?: string;
}

export function Section({ id, title, children, className = '' }: SectionProps) {
  return (
    <section id={id} className={`py-20 ${className}`}>
      <div className="container mx-auto px-4">
        {title && (
          <motion.h2
            className="text-3xl md:text-4xl font-cyber text-cyber-green mb-12 text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="text-cyber-cyan">{'<'}</span>
            {title}
            <span className="text-cyber-cyan">{'/>'}</span>
          </motion.h2>
        )}
        {children}
      </div>
    </section>
  );
}
